import { render, staticRenderFns } from "./BibliotecaSearch.vue?vue&type=template&id=62ea67dd&"
import script from "./BibliotecaSearch.vue?vue&type=script&lang=ts&"
export * from "./BibliotecaSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports